import * as Sentry from '@sentry/browser'

const { REACT_APP_SENTRY_DSN, REACT_APP_VERSION, REACT_APP_STAGE } = process.env

export function init() {
    if (!REACT_APP_SENTRY_DSN || !REACT_APP_VERSION || !REACT_APP_STAGE) {
        console.warn('Sentry initialization skipped, no configurations available')
    } else {
        Sentry.init({
            environment: REACT_APP_STAGE,
            dsn: REACT_APP_SENTRY_DSN,
            release: `dsk-${REACT_APP_STAGE}-${REACT_APP_VERSION}`,
        })
    }
}

export function captureException(error: Error) {
    Sentry.captureException(error)
}
